module.exports = __webpack_public_path__ + "img/professional.3b61c216.svg";